export default class UcetService {
  constructor(server){
    this.server = server;
  }
 
  get(id){
    return this.server("ucet.get", {id: id});
  }

  save(id, item){
    return this.server("ucet.update", {id: id, data: item});
  }

}


// WEBPACK FOOTER //
// ./src/Ucet/UcetService.js